export enum VacancySyncState {
  Synced = 0,
  Removed = 1,
  NotSynced = 2,
}

export type VacancySyncStateApiValue = VacancySyncState | keyof typeof VacancySyncState;

export type VacancySyncOverviewDto = {
  vacancyId: number;
  vacancyTitle: string | null;
  isDeleted: boolean;
  issueDescriptionKey: string;
  publicationDate: string | null;
  postingId: string | null;
  trackingKey: string | null;
  lastSyncDate: string | null;
  syncState: VacancySyncStateApiValue | null;
  segmentId: string | null;
  segmentName: string | null;
  companyName: string | null;
  exceptionCode: string | null;
  isSegmentArchived: boolean;
};

export type PaginatedVacancySyncOverviewResponse = {
  data: VacancySyncOverviewDto[];
  page: number;
  pageSize: number;
  totalRecords: number;
};

export type RepairVacanciesResponse = {
  message: string;
};

export type ResyncVacanciesResponse = {
  message: string;
};

export type ClientJobSyncOverviewDto = {
  clientId: string;
  clientName: string;
  moduleStatus: boolean;
  lastSyncTimestamp: string | null;
  totalLiveVacanciesCount: number;
  syncedVacanciesCount: number;
  isSegmentUsed: boolean;
  sourceName?: string | null;
  feedStatus?: string | null;
  feedId?: string | null;
  registrationDate?: string | null;
};

export type PaginatedClientJobSyncOverviewResponse = {
  data: ClientJobSyncOverviewDto[];
  page: number;
  pageSize: number;
  totalRecords: number;
};
